/**
 * MODULE: useEmailTemplateSavedCoaching.ts
 * PURPOSE: Append assistant coaching message after golden-path template save from assistant UX.
 */

import { useEffect } from 'react';
import { subscribeEmailTemplateCreated } from '@shared/lib/frontend/utils/emailTemplateCreateBridge';
import { buildEmailTemplateSavedCoachingMessage } from '../../components/assistant/emailTemplateSavedCoaching';

export function useEmailTemplateSavedCoaching(
  appendAssistantText: (text: string) => void
): void {
  useEffect(() => {
    return subscribeEmailTemplateCreated((detail) => {
      const msg = buildEmailTemplateSavedCoachingMessage(detail);
      if (msg) appendAssistantText(msg);
    });
  }, [appendAssistantText]);
}
